import { FormWorkflowStatus, FormWorkflowTransition } from 'src/shared/store/projects/types';

export const HISTORY_PAGE_SIZE = 20;
export const MAX_WORKFLOW_COMMENT_LENGTH = 512000;

export const normalizeWorkflowRuntimeRole = (value?: string): string => {
  const normalized = (value || '').trim().toLowerCase();
  if (normalized === 'form_developer') {
    return 'form_designer';
  }
  return normalized;
};

export const normalizeWorkflowRuntimeStatus = (value?: string): string =>
  (value || '').trim().toLowerCase();

export const normalizeWorkflowRuntimeUserId = (value?: number | null): number => {
  const normalized = Number(value);
  if (!Number.isFinite(normalized) || normalized <= 0) {
    return 0;
  }
  return Math.trunc(normalized);
};

export const workflowActorMatchesAssignments = (
  allowedUserIds?: number[],
  userId?: number | null,
): boolean => {
  if (!allowedUserIds?.length) {
    return true;
  }

  const normalizedUserId = normalizeWorkflowRuntimeUserId(userId);
  if (!normalizedUserId) {
    return false;
  }

  return allowedUserIds.some(
    allowedUserId => normalizeWorkflowRuntimeUserId(allowedUserId) === normalizedUserId,
  );
};

export const isWorkflowTransitionAllowedForActor = (
  transition: FormWorkflowTransition,
  userRole?: string,
  userId?: number | null,
): boolean => {
  if (!transition.allowedRoles?.length) {
    return workflowActorMatchesAssignments(transition.allowedUserIds, userId);
  }

  const normalizedRole = normalizeWorkflowRuntimeRole(userRole);
  const roleAllowed = transition.allowedRoles.some(
    allowedRole => normalizeWorkflowRuntimeRole(allowedRole) === normalizedRole,
  );

  if (!roleAllowed) {
    return false;
  }

  return workflowActorMatchesAssignments(transition.allowedUserIds, userId);
};

export const formatWorkflowDate = (value: string): string => {
  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return value;
  }
  return parsedDate.toLocaleString('ru-RU');
};

export const getWorkflowStatusLabel = (
  statusCode: string,
  statusMap: Record<string, FormWorkflowStatus>,
): string => {
  const normalized = normalizeWorkflowRuntimeStatus(statusCode);
  const mappedDefaults: Record<string, string> = {
    draft: 'Черновик',
    review: 'Проверка',
    approved: 'Утверждено',
    rejected: 'Отклонено',
    disabled: 'Выключено',
  };
  return statusMap[normalized]?.name || mappedDefaults[normalized] || normalized || '-';
};

export const buildLinearWorkflowRuntimeTransitions = (
  statuses: FormWorkflowStatus[],
): FormWorkflowTransition[] => {
  if (statuses.length < 2) {
    return [];
  }

  return statuses.slice(0, -1).map((status, index) => ({
    from: status.code,
    to: statuses[index + 1].code,
  }));
};
